import { shallowRef } from 'vue'
import { useI18n } from 'vue-i18n'
import useBlProviders from '@/composables/providers/useBlProvider'
import IdentityCardsDt from '@/services/dataTransferModules/identityCardsDt'

const identityCardsDt = new IdentityCardsDt()

export default function useIdentityCards() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullIdentityCards,
		getEntities: getFulledIdentityCards,

		basedEntities: baseIdentityCards,
		getBasedEntities: getBaseIdentityCards,

		extendedEntities: extendedIdentityCards,
		getExtendedEntities: getExtendedIdentityCards,

		entityPreview: identityCardsPreview,
		getEntityPreview: getIdentityPreview,

		entity: identityCard,
		getEntity: getIdentityCard,

		createEntity: createIdentityCard,
		patchEntity: updateIdentityCard,
		deleteEntity: deleteIdentityCard,
	} = useBlProviders(identityCardsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading identification cards'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error while adding identifier'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error while editing identity card'),

		showErrorNotificationForDeletingEntity: true,
	})

	flags.isLoadingHashedFulledIdentityCards = false

	const defaults = {
		creatingIdentityCards: {
			code: '',
			type: null,
		},
		fieldsToPatch: ['code', 'type'],
	}

	/**
	 * Провайдер хеширует getHashedEntities по id, а этой сущности нужен хеш по code —
	 * собираем хеш вручную поверх стандартного getEntities.
	 */
	const hashedFulledIdentityCards = shallowRef({})
	const getHashedFulledIdentityCards = () => {
		return new Promise((resolve, reject) => {
			flags.isLoadingHashedFulledIdentityCards = true

			getFulledIdentityCards()
				.then((res) => {
					const _hashedFulledIdentityCards = res.reduce((acc, obj) => {
						acc[obj.code] = obj
						return acc
					}, {})

					hashedFulledIdentityCards.value = _hashedFulledIdentityCards
					flags.isLoadingHashedFulledIdentityCards = false
					resolve(_hashedFulledIdentityCards)
				})
				.catch((err) => {
					flags.isLoadingHashedFulledIdentityCards = false
					reject(err)
				})
		})
	}

	return {
		flags,
		fullIdentityCards,
		baseIdentityCards,
		extendedIdentityCards,
		identityCardsPreview,
		identityCard,
		updateIdentityCard,
		getBaseIdentityCards,
		getExtendedIdentityCards,
		getFulledIdentityCards,
		getIdentityPreview,
		getIdentityCard,
		createIdentityCard,
		deleteIdentityCard,
		defaults,

		hashedFulledIdentityCards,
		getHashedFulledIdentityCards,
	}
}
